import { useEffect } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

const Home = () => {
    const token = useSelector((s) => s.token.value);

    const navigate = useNavigate();

    useEffect(() => {
        navigate(token ? "/attendance" : "/login");
    }, [token]);

    return <></>;
};

export default Home;
